import React, { useState } from 'react';
import { BONUS_LIST } from '../components/BonusList';
import SectionAd from '../components/ads/SectionAd';

// Raggruppa i bonus per categoria
function Rules() {
    const [expandedRow, setExpandedRow] = useState(null);
    const [activeMode, setActiveMode] = useState('indipendente');

    const toggleRow = (value) => {
        setExpandedRow(prev => (prev === value ? null : value));
    };

    const handleAccordionChange = (e) => {
        const trigger = e.currentTarget;
        const targetId = trigger.getAttribute('data-bs-target');

        if (targetId?.startsWith('#')) {
            const collapseEl = document.querySelector(targetId);
            const accordionItem = trigger.closest('.rules-accordion-item');

            setTimeout(() => {
                const isOpen = collapseEl?.classList.contains('show');
                const scrollTarget = isOpen ? accordionItem : trigger;

                scrollTarget?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }, 220);
        }
    };

    const renderRows = (items) =>
        items.map((item) => (
            <tr key={item.value}>
                <td onClick={() => toggleRow(item.value)} className="clickable">
                    <div className="d-flex justify-content-between align-items-center fw-bold">
                        <span>{item.label}</span>
                    </div>
                    <div
                        className="detail-wrapper"
                        style={{
                            maxHeight: expandedRow === item.value ? '100px' : '0px'
                        }}
                    >
                        <div className="detail-wrapper-inner text-brand-muted">
                            {item.desc}
                        </div>
                    </div>
                </td>
                <td
                    className={`text-center points-cell fw-bold ${item.points >= 0 ? 'positive text-success' : 'negative text-danger'
                        }`}
                >
                    {item.points >= 0 ? `+${item.points}` : item.points}
                </td>
                {item.pointsExt !== undefined && item.pointsExt !== null ? (
                    <td>
                        <div className={`text-center points-cell fw-bold ${item.pointsExt >= 0 ? 'positive text-success' : 'negative text-danger'}`}>
                            {item.pointsExt >= 0 ? `+${item.pointsExt}` : item.pointsExt}
                        </div>
                    </td>
                ) : (
                    <td>
                        <div className="text-center points-cell fw-bold" style={{ color: 'rgba(255,255,255,0.3)' }}>
                            —
                        </div>
                    </td>
                )}
            </tr>
        ));


    return (
        <div className="rules-page" style={{
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
            padding: '2rem 0'
        }}>
            <div className="container rules-container">
                <div className="rules-header text-center ">
                    <h1 className="mb-3 fw-bold text-center text-brand-secondary" style={{
                        fontFamily: "'Cinzel Decorative'",
                        textShadow: '1px 1px 2px rgba(0, 0, 0)'
                    }}>
                        <i className="bi bi-journal-text me-3" style={{
                            fontSize: '3rem',
                            filter: 'drop-shadow(0 2px 4px rgba(194, 157, 84, 0.4))'
                        }} />
                        Regole
                    </h1>
                    <p className="mt-3" style={{
                        color: 'var(--brand-primary)',
                        fontSize: '1.1rem',
                        opacity: 0.8
                    }}>Scopri come funziona FantaWrestling</p>
                </div>

                <div className="accordion custom-accordion rules-accordion-dark" id="accordionRegole" style={{
                    backgroundColor: 'transparent',
                    border: 'none'
                }}>
                    {/* Parte 1 - Modalità di Gioco e Creazione Fazione */}
                    <div className="accordion-item shadow-sm mb-4 rules-accordion-item" style={{
                        border: 'none',
                        borderRadius: 'var(--border-radius)',
                        background: 'white',
                        overflow: 'hidden',
                        transition: 'var(--transition)'
                    }}>
                        <h2 className="accordion-header" id="headingOne" style={{
                            background: 'linear-gradient(135deg, var(--brand-primary), var(--brand-primary-light))'
                        }}>
                            <button
                                className="accordion-button rules-accordion-button"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseOne"
                                aria-expanded="true"
                                aria-controls="collapseOne"
                                onClick={handleAccordionChange}
                                style={{
                                    backgroundColor: 'transparent',
                                    color: 'white',
                                    borderBottom: 'none',
                                    fontSize: '1.1rem',
                                    boxShadow: 'none'
                                }}>
                                <i className="bi bi-people-fill rules-accordion-icon"></i>
                                <span className="fw-bold rules-accordion-title">Parte 1: Modalità di Gioco e Creazione Fazione</span>
                            </button>
                        </h2>
                        <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionRegole" aria-labelledby="headingOne">
                            <div className="accordion-body rules-accordion-body">
                                <div className="intro-card mb-4 p-4 rounded" style={{
                                    background: 'var(--brand-primary-light)',
                                    color: 'white',
                                    borderLeft: '4px solid var(--brand-secondary)'
                                }}>
                                    <h5 className="fw-bold mb-3" style={{ color: 'var(--brand-secondary)' }}>Introduzione</h5>
                                    <ul className="mb-0">
                                        <li>Per partecipare al <strong className="text-brand-secondary-light">FantaWrestling</strong> esistono due modalità di gioco</li>
                                        <li>Ogni giocatore partecipa all'interno di un <strong className="text-brand-secondary-light">Roster</strong> nel quale si sfida con gli altri giocatori. Ognuno di loro avrà una fazione composta da più wrestler </li>
                                        <li>Esistono 5 modalità: tre per giocare in un roster privato con gli amici, il <strong className="text-brand-secondary-light">competitivo</strong>, l'<strong className="text-brand-secondary-light">indipendente privato</strong> e <strong className="text-brand-secondary-light">modalità GM</strong>, e due aperte a tutti, l'<strong className="text-brand-secondary-light">indipendente</strong> e la <strong className="text-brand-secondary-light">Road To</strong></li>
                                    </ul>
                                </div>

                                {/* Selezione modalità */}
                                <div className="mode-selector mb-4">
                                    <h5 className="fw-bold mb-3">Scegli la modalità di gioco:</h5>
                                    <div className="d-flex flex-row flex-wrap gap-3">
                                        {/* Modalità Indipendente */}
                                        <button
                                            type="button"
                                            className={`mode-btn btn flex-grow-1`}
                                            onClick={() => setActiveMode('indipendente')}
                                            style={{
                                                minWidth: '140px',
                                                background: activeMode === 'indipendente'
                                                    ? 'linear-gradient(135deg, var(--brand-primary), var(--brand-primary-light))'
                                                    : 'rgba(54, 135, 206, 0.1)',
                                                color: activeMode === 'indipendente' ? 'white' : 'var(--brand-primary-ultralight)',
                                                border: `2px solid ${activeMode === 'indipendente' ? 'var(--brand-primary)' : 'rgba(54, 135, 206, 0.2)'}`,
                                                transition: 'var(--transition)',
                                                padding: '1rem'
                                            }}
                                        >
                                            <i className="bi bi-list-ul me-2"></i>
                                            <div>
                                                <div className="fw-bold">Indipendente</div>
                                                <small className="d-block">Pubblica o privata</small>
                                            </div>
                                        </button>

                                        {/* Modalità Competitiva */}
                                        <button
                                            type="button"
                                            className={`mode-btn btn flex-grow-1`}
                                            onClick={() => setActiveMode('competitivo')}
                                            style={{
                                                minWidth: '140px',
                                                background: activeMode === 'competitivo'
                                                    ? 'linear-gradient(135deg, var(--brand-secondary), var(--brand-secondary-light))'
                                                    : 'rgba(194, 157, 84, 0.1)',
                                                color: activeMode === 'competitivo' ? 'var(--brand-primary)' : 'var(--brand-secondary)',
                                                border: `2px solid ${activeMode === 'competitivo' ? 'var(--brand-secondary)' : 'rgba(194, 157, 84, 0.2)'}`,
                                                transition: 'var(--transition)',
                                                padding: '1rem'
                                            }}
                                        >
                                            <i className="bi bi-trophy me-2"></i>
                                            <div>
                                                <div className="fw-bold">Competitiva</div>
                                                <small className="d-block">Asta tra partecipanti</small>
                                            </div>
                                        </button>

                                        {/* Modalità GM */}
                                        <button
                                            type="button"
                                            className={`mode-btn btn flex-grow-1`}
                                            onClick={() => setActiveMode('gm')}
                                            style={{
                                                minWidth: '140px',
                                                background: activeMode === 'gm'
                                                    ? 'linear-gradient(135deg, #6f42c1, #8b5cf6)'
                                                    : 'rgba(111, 66, 193, 0.1)',
                                                color: activeMode === 'gm' ? 'white' : '#8b5cf6',
                                                border: `2px solid ${activeMode === 'gm' ? '#6f42c1' : 'rgba(111, 66, 193, 0.2)'}`,
                                                transition: 'var(--transition)',
                                                padding: '1rem'
                                            }}
                                        >
                                            <i className="bi bi-person-badge me-2"></i>
                                            <div>
                                                <div className="fw-bold">GM</div>
                                                <small className="d-block">General Manager</small>
                                            </div>
                                        </button>

                                        {/* Modalità Road To */}
                                        <button
                                            type="button"
                                            className={`mode-btn btn flex-grow-1`}
                                            onClick={() => setActiveMode('roadto')}
                                            style={{
                                                minWidth: '140px',
                                                background: activeMode === 'roadto'
                                                    ? 'linear-gradient(135deg, #dc3545, #e4606d)'
                                                    : 'rgba(220, 53, 69, 0.1)',
                                                color: activeMode === 'roadto' ? 'white' : '#dc3545',
                                                border: `2px solid ${activeMode === 'roadto' ? '#dc3545' : 'rgba(220, 53, 69, 0.2)'}`,
                                                transition: 'var(--transition)',
                                                padding: '1rem'
                                            }}
                                        >
                                            <i className="bi bi-signpost-2 me-2"></i>
                                            <div>
                                                <div className="fw-bold">Road To</div>
                                                <small className="d-block">Eventi speciali</small>
                                            </div>
                                        </button>
                                    </div>
                                </div>

                                {/* Contenuto modale */}
                                <div className="mode-content">
                                    {/* Contenuto Indipendente */}
                                    <div className={`mode-section ${activeMode === 'indipendente' ? 'd-block' : 'd-none'}`}>
                                        <div className="card mb-3 rules-content-card" style={{
                                            border: 'none',
                                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
                                        }}>
                                            <div className="card-body">
                                                <h5 className="card-title fw-bold" style={{ color: 'var(--brand-primary)' }}>
                                                    <i className="bi bi-list-ul me-2" style={{ color: 'var(--brand-secondary)' }}></i>
                                                    Modalità Indipendente
                                                </h5>
                                                <ul className="list-group list-group-flush">
                                                    <li className="list-group-item">
                                                        <i className="bi bi-check-circle-fill text-success me-2"></i>
                                                        Acquisti da listone unico condiviso tra tutti i giocatori
                                                    </li>
                                                    <li className="list-group-item">
                                                        <i className="bi bi-check-circle-fill text-success me-2"></i>
                                                        Ideale per roster molto grandi (anche centinaia di partecipanti)
                                                    </li>
                                                    <li className="list-group-item">
                                                        <i className="bi bi-info-circle-fill text-brand-secondary me-2"></i>
                                                        È l'unica modalità che può essere giocata sia in modalità pubblica che privata
                                                    </li>
                                                    <li className="list-group-item">
                                                        <i className="bi bi-info-circle-fill text-brand-secondary me-2"></i>
                                                        In caso di leghe pubbliche gestite dallo staff FantaWrestling, le regole potrebbero cambiare ad ogni roster generato
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Contenuto Competitivo */}
                                    <div className={`mode-section ${activeMode === 'competitivo' ? 'd-block' : 'd-none'}`}>
                                        <div className="card mb-3 rules-content-card">
                                            <div className="card-body">
                                                <h5 className="card-title fw-bold">
                                                    <i className="bi bi-trophy me-2 text-brand-primary-ultralight"></i>
                                                    Modalità Competitiva
                                                </h5>
                                                <ul className="list-group list-group-flush">
                                                    <li className="list-group-item">
                                                        <i className="bi bi-check-circle-fill text-success me-2"></i>
                                                        Assegnazione wrestler mediante asta tra i partecipanti
                                                    </li>
                                                    <li className="list-group-item">
                                                        <i className="bi bi-check-circle-fill text-success me-2"></i>
                                                        Ogni wrestler può essere posseduto da una sola fazione
                                                    </li>
                                                    <li className="list-group-item">
                                                        <i className="bi bi-check-circle-fill text-success me-2"></i>
                                                        Adatto a roster privati con amici (5-15 partecipanti)
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Contenuto GM */}
                                    <div className={`mode-section ${activeMode === 'gm' ? 'd-block' : 'd-none'}`}>
                                        <div className="card mb-3 rules-content-card">
                                            <div className="card-body">
                                                <h5 className="card-title fw-bold" style={{ color: '#8b5cf6' }}>
                                                    <i className="bi bi-person-badge me-2"></i>
                                                    Modalità GM (General Manager)
                                                </h5>
                                                <ul className="list-group list-group-flush">
                                                    <li className="list-group-item">
                                                        <i className="bi bi-check-circle-fill text-success me-2"></i>
                                                        Versione alternativa del competitivo con un General Manager gestisce i match tra giocatori
                                                    </li>
                                                    <li className="list-group-item">
                                                        <i className="bi bi-check-circle-fill text-success me-2"></i>
                                                        Permette di far scontrare in match diretti due o più giocatori
                                                    </li>
                                                    <li className="list-group-item">
                                                        <i className="bi bi-check-circle-fill text-success me-2"></i>
                                                        La classifica non è basata sui punti delle fazioni, ma sui match vinti
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Contenuto Road To */}
                                    <div className={`mode-section ${activeMode === 'roadto' ? 'd-block' : 'd-none'}`}>
                                        <div className="card mb-3 rules-content-card">
                                            <div className="card-body">
                                                <h5 className="card-title fw-bold" style={{ color: '#dc3545' }}>
                                                    <i className="bi bi-signpost-2 me-2"></i>
                                                    Modalità Road To
                                                </h5>
                                                <ul className="list-group list-group-flush">
                                                    <li className="list-group-item">
                                                        <i className="bi bi-check-circle-fill text-success me-2"></i>
                                                        Modalità dedicata agli eventi speciali della WWE, come WrestleMania, SummerSlam o Survivor Series
                                                    </li>
                                                    <li className="list-group-item">
                                                        <i className="bi bi-check-circle-fill text-success me-2"></i>
                                                        Ha una durata ben precisa, con un inizio e una fine definiti fin da subito
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Regole comuni */}
                                <div className="common-rules mt-4">
                                    <h5 className="fw-bold mb-3">
                                        <i className="bi bi-card-checklist me-2 text-brand-primary-ultralight"></i>
                                        Regole Comuni
                                    </h5>
                                    <div className="list-group-rules">
                                        <div className="list-group-rules-item">
                                            <i className="bi bi-arrow-right-circle-fill text-brand-primary-ultralight me-2"></i>
                                            <strong>Valore individuale</strong>: Ogni wrestler vale come singolo, anche se parte di tag team o stable.
                                        </div>
                                        <div className="list-group-rules-item">
                                            <i className="bi bi-arrow-right-circle-fill text-brand-primary-ultralight me-2"></i>
                                            <strong>Cambi gimmick</strong>: Il wrestler mantiene il posto in fazione. (Es. El grande americano, se smascherato, diventa colui che è stato smascherato)
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Parte 2 - Punteggi */}
                    <div className="accordion-item shadow-sm mb-4 rules-accordion-item" style={{
                        border: 'none',
                        borderRadius: 'var(--border-radius)',
                        background: 'white',
                        overflow: 'hidden'
                    }}>
                        <h2 className="accordion-header" id="headingTwo" style={{
                            background: 'linear-gradient(135deg, var(--brand-secondary), var(--brand-secondary-light))'
                        }}>
                            <button
                                className="accordion-button collapsed rules-accordion-button"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseTwo"
                                aria-expanded="false"
                                aria-controls="collapseTwo"
                                onClick={handleAccordionChange}
                                style={{
                                    backgroundColor: 'transparent',
                                    color: 'var(--brand-primary)',
                                    borderBottom: 'none',
                                    fontSize: '1.1rem',
                                    boxShadow: 'none'
                                }}>
                                <i className="bi bi-trophy-fill rules-accordion-icon"></i>
                                <span className="fw-bold rules-accordion-title">Parte 2: Sistema Punteggi</span>
                            </button>
                        </h2>
                        <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionRegole" aria-labelledby="headingTwo">
                            <div className="accordion-body rules-accordion-body">
                                <div className="scoring-rules">
                                    {/* Informazioni Generali - aggiornate */}
                                    <div className="card mb-4 rules-content-card" style={{
                                        border: 'none',
                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                                        borderTop: '3px solid var(--brand-secondary)'
                                    }}>
                                        <div className="card-body">
                                            <h5 className="card-title fw-bold" style={{ color: 'var(--brand-primary)' }}>
                                                <i className="bi bi-info-circle-fill me-2" style={{ color: 'var(--brand-secondary)' }}></i>
                                                Informazioni Generali
                                            </h5>
                                            <ol>
                                                <li>Il FantaWrestling è un gioco che si basa su eventi e risultati degli show di Pro Wrestling. Il proprio regolamento varia dalla modalità di gioco: <strong>Competitivo</strong>, con una massima personalizzazione, e <strong>Indipendente</strong>, con regole standard.</li>
                                                <li>I punti assegnati ai wrestler <strong>non sono in alcun modo retroattivi</strong>.</li>
                                                <li>I wrestler una volta svincolati salvano il punteggio effettuato fino a quel momento nella propria fazione; i nuovi acquisti portano nuovi punti alla fazione dal primo show disponibile.</li>
                                                <li>La competizione ha inizio in una data predefinita fino alla conclusione dell'edizione successiva di <strong>WrestleMania</strong>. Vince chi, terminato WrestleMania, ha totalizzato il <strong>maggior numero di punti</strong>.</li>
                                            </ol>
                                        </div>
                                    </div>

                                    {/* Precisazioni Importanti - aggiornate */}
                                    <div className="card mb-4 rules-content-card" style={{
                                        border: 'none',
                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                                        borderTop: '3px solid var(--brand-accent)'
                                    }}>
                                        <div className="card-body">
                                            <h5 className="card-title fw-bold" style={{ color: 'var(--brand-accent)' }}>
                                                <i className="bi bi-exclamation-triangle-fill me-2"></i>
                                                Precisazioni Importanti
                                            </h5>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="p-3 rounded mb-3" style={{
                                                        background: 'rgba(89, 132, 170, 0.05)',
                                                        borderLeft: '3px solid var(--brand-primary-ultralight)'
                                                    }}>
                                                        <h6 className="fw-bold">Copertura Show</h6>
                                                        <p className="mb-0">A tutte le superstar WWE, sia del Main Roster che di NXT, vengono considerati tutti i bonus e i malus. I wrestler faranno punti in tutti gli show WWE, NXT, AAA e TNA in cui partecipano, che siano settimanali, eventi speciali e PLE/PPV.</p>
                                                        <small>Gli ultimi considerati come show extra</small>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="p-3 rounded mb-3" style={{
                                                        background: 'rgba(194, 157, 84, 0.05)',
                                                        borderLeft: '3px solid var(--brand-secondary)'
                                                    }}>
                                                        <h6 className="fw-bold">Titoli Riconosciuti</h6>
                                                        <p className="mb-0">Sono riconosciuti i titoli massimi, titoli singoli e titoli tag team, sia maschili che femminili, del Main Roster, di NXT, TNA e AAA. Eventuali altri titoli non sono considerati.</p>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="p-3 rounded mb-3" style={{
                                                        background: 'rgba(255, 22, 22, 0.05)',
                                                        borderLeft: '3px solid var(--brand-accent)'
                                                    }}>
                                                        <h6 className="fw-bold">Eventi Speciali</h6>
                                                        <p className="mb-0">Per convenzione e semplicità di organizzazione, gli eventi speciali (come Saturday Night Main Event, Slammy Awards) saranno considerati come PLE.</p>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="p-3 rounded mb-3" style={{
                                                        background: 'rgba(89, 132, 170, 0.05)',
                                                        borderLeft: '3px solid var(--brand-primary-ultralight)'
                                                    }}>
                                                        <h6 className="fw-bold">Interferenza attiva</h6>
                                                        <p className="mb-0">Assegnato ai wrestler che agiscono attivamente rendendosi partecipi dell'esito del match.</p>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="p-3 rounded mb-3" style={{
                                                        background: 'rgba(194, 157, 84, 0.05)',
                                                        borderLeft: '3px solid var(--brand-secondary)'
                                                    }}>
                                                        <h6 className="fw-bold">Spacca oggetto</h6>
                                                        <p className="mb-0">Rottura di un oggetto contundente verso l'avversario. I classici esempi sono il tavolo dei commentatori o di legno, il bastone da kendo o qualsiasi altro oggetto che si rompa. Attivo è chi attacca, passivo è chi subisce l'attacco.</p>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="p-3 rounded mb-3" style={{
                                                        background: 'rgba(255, 22, 22, 0.05)',
                                                        borderLeft: '3px solid var(--brand-accent)'
                                                    }}>
                                                        <h6 className="fw-bold">Spacca ring</h6>
                                                        <p className="mb-0">Rottura evidente del ring o di oggetti contundenti. Si considerano esempi come Big Show vs Braun Strowman, Brock Lesnar con il trattore e i buchi nel ring di Kane o Bray Wyatt.</p>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="p-3 rounded mb-3" style={{
                                                        background: 'rgba(89, 132, 170, 0.05)',
                                                        borderLeft: '3px solid var(--brand-primary-ultralight)'
                                                    }}>
                                                        <h6 className="fw-bold">Botch</h6>
                                                        <p className="mb-0">Errori evidenti. Non sono considerate quelle manovre e mosse con piccole sbavature dovute all'alto livello di difficoltà di esecuzione.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <h5 className="fw-bold mb-4">
                                        <i className="bi bi-table me-2" style={{ color: 'var(--brand-secondary)' }}></i>
                                        Tabella Punteggi
                                    </h5>
                                    <div className="rules-table-responsive">
                                        <table className="rules-table rules-table-dark table table-hover table-dark" style={{ boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)', borderRadius: '0.5rem', overflow: 'hidden' }}>
                                            <thead style={{ background: 'linear-gradient(135deg, var(--brand-primary), var(--brand-primary-light))' }}>
                                                <tr>
                                                    <th width="75%" style={{ color: 'white', padding: '1rem', fontSize: '1rem' }}>Descrizione <br /><small style={{ fontSize: '0.65rem', opacity: 0.9 }}>(clicca per dettagli)</small></th>
                                                    <th width="25%" style={{ color: 'white', padding: '1rem', fontSize: '1rem', textAlign: 'center' }}>Punti</th>
                                                    <th width="25%" style={{ color: 'white', padding: '1rem', fontSize: '0.8rem', textAlign: 'center' }}>NXT & Extra</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {/* SEZIONE 1: SETTIMANALI */}
                                                <tr style={{ background: 'rgba(38, 56, 72, 0.15)', borderTop: '3px solid var(--brand-secondary)' }}>
                                                    <th className="fw-bold" colSpan="3" style={{ color: 'var(--brand-secondary)', fontWeight: 700, padding: '0.75rem 1rem', fontSize: '1rem' }}>
                                                        Show settimanali
                                                    </th>
                                                </tr>
                                                {renderRows(BONUS_LIST.filter(b => b.cat === 'sett'))}

                                                {/* SEZIONE 2: GENERALI */}
                                                <tr style={{ background: 'rgba(38, 56, 72, 0.15)', borderTop: '3px solid var(--brand-secondary)' }}>
                                                    <th className="fw-bold" colSpan="3" style={{ color: 'var(--brand-secondary)', fontWeight: 700, padding: '0.75rem 1rem', fontSize: '1rem' }}>
                                                        Tutti gli show
                                                    </th>
                                                </tr>
                                                {renderRows(BONUS_LIST.filter(b => b.cat === 'both' && b.points >= 0))}
                                                {renderRows(BONUS_LIST.filter(b => b.cat === 'both' && b.points < 0))}

                                                {/* SEZIONE 3: PLE */}
                                                <tr style={{ background: 'rgba(38, 56, 72, 0.15)', borderTop: '3px solid var(--brand-secondary)' }}>
                                                    <th className="fw-bold" colSpan="3" style={{ color: 'var(--brand-secondary)', fontWeight: 700, padding: '0.75rem 1rem', fontSize: '1rem' }}>
                                                        PLE e PPV
                                                    </th>
                                                </tr>
                                                {renderRows(BONUS_LIST.filter(b => b.cat === 'ple' && b.points >= 0))}
                                                {renderRows(BONUS_LIST.filter(b => b.cat === 'ple' && b.points < 0))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Parte 3 - Modalità GM */}
                    <div className="accordion-item shadow-sm mb-4 rules-accordion-item" style={{
                        border: 'none',
                        borderRadius: 'var(--border-radius)',
                        background: 'white',
                        overflow: 'hidden'
                    }}>
                        <h2 className="accordion-header" id="headingThree" style={{
                            background: 'linear-gradient(135deg, #6f42c1, #8b5cf6)'
                        }}>
                            <button
                                className="accordion-button collapsed rules-accordion-button"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseThree"
                                aria-expanded="false"
                                aria-controls="collapseThree"
                                onClick={handleAccordionChange}
                                style={{
                                    backgroundColor: 'transparent',
                                    color: 'white',
                                    borderBottom: 'none',
                                    fontSize: '1.1rem',
                                    boxShadow: 'none'
                                }}
                            >
                                <i className="bi bi-controller rules-accordion-icon"></i>
                                <span className="fw-bold rules-accordion-title">Parte 3: Modalità GM</span>
                            </button>
                        </h2>
                        <div
                            id="collapseThree"
                            className="accordion-collapse collapse"
                            data-bs-parent="#accordionRegole"
                            aria-labelledby="headingThree"
                        >
                            <div className="accordion-body rules-accordion-body">
                                <div className="card mb-4 rules-content-card" style={{
                                    border: 'none',
                                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                                    borderTop: '4px solid #8b5cf6'
                                }}>
                                    <div className="card-body">
                                        <h5 className="card-title fw-bold" style={{ color: '#6f42c1' }}>
                                            <i className="bi bi-diagram-3-fill me-2" style={{ color: '#8b5cf6' }}></i>
                                            Struttura della modalità
                                        </h5>
                                        <p>
                                            La <strong>modalità GM</strong> si basa sui punti realizzati negli show dal
                                            <strong> lunedì alla domenica</strong> organizzando sfide dirette tra fazioni.
                                            In questa modalità la classifica dipende solo dai <strong>punti ottenuti nei match</strong>.
                                        </p>
                                        <div className="row g-3 mt-1">
                                            <div className="col-md-6">
                                                <div className="p-3 rounded rules-soft-panel rules-gm-panel">
                                                    <h6 className="fw-bold">Calendario</h6>
                                                    <ul className="mb-0">
                                                        <li>Il calendario viene generato automaticamente in match 1vs1.</li>
                                                        <li>Il GM può comunque impostare match 1v1, triple threat, fatal 4 way, 6-pack challenge o battle royal.</li>
                                                        <li>Nelle battle royal partecipano tutte le fazioni coinvolte nel turno.</li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="p-3 rounded rules-soft-panel rules-gm-panel">
                                                    <h6 className="fw-bold">Vittorie</h6>
                                                    <ul className="mb-0">
                                                        <li>Una fazione vince se totalizza almeno <strong>un punto in più</strong> rispetto all'avversaria.</li>
                                                        <li>Se il punteggio è identico si verifica un <strong>pareggio</strong>.</li>
                                                        <li>Nel GM contano soltanto i risultati delle sfide e non il totale stagionale della fazione.</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card rules-content-card" style={{
                                    border: 'none',
                                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                                    borderTop: '4px solid #6f42c1'
                                }}>
                                    <div className="card-body">
                                        <h5 className="card-title fw-bold" style={{ color: '#6f42c1' }}>
                                            <i className="bi bi-trophy-fill me-2" style={{ color: '#8b5cf6' }}></i>
                                            Punti assegnati
                                        </h5>
                                        <ul className="list-group list-group-flush">
                                            <li className="list-group-item">
                                                <i className="bi bi-plus-circle-fill me-2" style={{ color: '#8b5cf6' }}></i>
                                                Chi vince un match ottiene un numero di punti pari ai <strong>partecipanti del match</strong>.
                                            </li>
                                            <li className="list-group-item">
                                                <i className="bi bi-stars me-2" style={{ color: '#8b5cf6' }}></i>
                                                Esempi: <strong>1v1 = 2 punti</strong>, <strong>1v1v1 = 3 punti</strong>, <strong>fatal 4 way = 4 punti</strong>.
                                            </li>
                                            <li className="list-group-item">
                                                <i className="bi bi-dash-circle-fill text-danger me-2"></i>
                                                Chi perde riceve <strong>0 punti</strong>.
                                            </li>
                                            <li className="list-group-item">
                                                <i className="bi bi-pause-circle-fill text-brand-secondary me-2"></i>
                                                In caso di pareggio tra due fazioni, entrambe ottengono <strong>1 punto</strong>.
                                            </li>
                                            <li className="list-group-item">
                                                <i className="bi bi-people-fill me-2" style={{ color: '#8b5cf6' }}></i>
                                                Nei match a più fazioni, se il punteggio migliore è condiviso da due o più fazioni, quelle fazioni prendono <strong>1 punto</strong> ciascuna e tutte le altre <strong>0 punti</strong>.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Parte 4 - Formazione */}
                    <div className="accordion-item shadow-sm mb-4 rules-accordion-item" style={{
                        border: 'none',
                        borderRadius: 'var(--border-radius)',
                        background: 'white',
                        overflow: 'hidden'
                    }}>
                        <h2 className="accordion-header" id="headingFour" style={{
                            background: 'linear-gradient(135deg, var(--brand-primary-ultralight), var(--brand-primary))'
                        }}>
                            <button
                                className="accordion-button collapsed rules-accordion-button"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseFour"
                                aria-expanded="false"
                                aria-controls="collapseFour"
                                onClick={handleAccordionChange}
                                style={{
                                    backgroundColor: 'transparent',
                                    color: 'white',
                                    borderBottom: 'none',
                                    fontSize: '1.1rem',
                                    boxShadow: 'none'
                                }}
                            >
                                <i className="bi bi-person-lines-fill rules-accordion-icon"></i>
                                <span className="fw-bold rules-accordion-title">Parte 4: Formazione</span>
                            </button>
                        </h2>
                        <div
                            id="collapseFour"
                            className="accordion-collapse collapse"
                            data-bs-parent="#accordionRegole"
                            aria-labelledby="headingFour"
                        >
                            <div className="accordion-body rules-accordion-body">
                                <div className="card mb-4 rules-content-card" style={{
                                    border: 'none',
                                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                                    borderTop: '4px solid var(--brand-primary-ultralight)'
                                }}>
                                    <div className="card-body">
                                        <h5 className="card-title fw-bold" style={{ color: 'var(--brand-primary)' }}>
                                            <i className="bi bi-layout-text-window-reverse me-2" style={{ color: 'var(--brand-secondary)' }}></i>
                                            Composizione e punteggio
                                        </h5>
                                        <p>
                                            La <strong>Line-Up</strong> è uno strumento facoltativo composto da un numero variabile di wrestler.
                                            Il risultato finale della fazione è dato dalla somma del <strong>Main Eventer</strong> e dei wrestler
                                            schierati <strong>in-ring</strong>.
                                        </p>
                                        <div className="row g-3 mt-1">
                                            <div className="col-md-4">
                                                <div className="p-3 rounded rules-soft-panel">
                                                    <h6 className="fw-bold">Main Eventer</h6>
                                                    <p className="mb-0">Raddoppia i propri punti per due settimane.</p>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="p-3 rounded rules-soft-panel">
                                                    <h6 className="fw-bold">In-Ring</h6>
                                                    <p className="mb-0">Aggiungono ulteriori punti in base ai bonus ottenuti negli show.</p>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="p-3 rounded rules-soft-panel">
                                                    <h6 className="fw-bold">Backstage</h6>
                                                    <p className="mb-0">Non fanno punti finché il giocatore non decide di spostarli in-ring.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card rules-content-card" style={{
                                    border: 'none',
                                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                                    borderTop: '4px solid var(--brand-secondary)'
                                }}>
                                    <div className="card-body">
                                        <h5 className="card-title fw-bold" style={{ color: 'var(--brand-primary)' }}>
                                            <i className="bi bi-arrow-repeat me-2" style={{ color: 'var(--brand-secondary)' }}></i>
                                            Vincoli di utilizzo
                                        </h5>
                                        <ul className="list-group list-group-flush">
                                            <li className="list-group-item">
                                                <i className="bi bi-lightbulb-fill text-brand-secondary me-2"></i>
                                                Il Main Eventer non è obbligatorio, ma è <strong>fortemente consigliato</strong>.
                                            </li>
                                            <li className="list-group-item">
                                                <i className="bi bi-clock-history text-brand-primary-ultralight me-2"></i>
                                                Un wrestler può essere Main Eventer per un massimo di <strong>due settimane</strong>.
                                            </li>
                                            <li className="list-group-item">
                                                <i className="bi bi-arrow-left-right me-2" style={{ color: 'var(--brand-secondary)' }}></i>
                                                Al termine di questo periodo il wrestler viene inserito in-ring e il giocatore dovrà scegliere un nuovo Main Eventer.
                                            </li>
                                            <li className="list-group-item">
                                                <i className="bi bi-pencil-square me-2" style={{ color: 'var(--brand-secondary)' }}></i>
                                                La line-up può essere modificata in qualsiasi momento, tranne durante uno show e fino alla pubblicazione dei risultati.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Parte 5 - Regole Finali */}
                    <div className="accordion-item shadow-sm mb-4 rules-accordion-item" style={{
                        border: 'none',
                        borderRadius: 'var(--border-radius)',
                        background: 'white',
                        overflow: 'hidden'
                    }}>
                        <h2 className="accordion-header" id="headingFive" style={{
                            background: 'linear-gradient(135deg, var(--brand-accent), var(--brand-accent-light))'
                        }}>
                            <button
                                className="accordion-button collapsed rules-accordion-button"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseFive"
                                aria-expanded="false"
                                aria-controls="collapseFive"
                                onClick={handleAccordionChange}
                                style={{
                                    backgroundColor: 'transparent',
                                    color: 'white',
                                    borderBottom: 'none',
                                    fontSize: '1.1rem',
                                    boxShadow: 'none'
                                }}
                            >
                                <i className="bi bi-gear-fill rules-accordion-icon"></i>
                                <span className="fw-bold rules-accordion-title">Parte 5: Avvertenze e precisazioni</span>
                            </button>
                        </h2>
                        <div
                            id="collapseFive"
                            className="accordion-collapse collapse"
                            data-bs-parent="#accordionRegole"
                            aria-labelledby="headingFive"
                        >
                            <div className="accordion-body rules-accordion-body">
                                <div className="card rules-content-card" style={{
                                    border: 'none',
                                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                                    borderTop: '4px solid var(--brand-accent)'
                                }}>
                                    <div className="card-body">
                                        <h5 className="card-title fw-bold" style={{ color: 'var(--brand-accent)' }}>
                                            <i className="bi bi-exclamation-triangle-fill me-2"></i>
                                            Importante
                                        </h5>
                                        <ul className="mb-4">
                                            <li>
                                                Qualora la valutazione di un bonus o di un malus non potesse essere
                                                puramente oggettiva, l'assegnazione di tale bonus/malus sarà decisa
                                                dal <strong>Team Punteggi</strong> che valuterà l’accaduto in modo{" "}
                                                <strong>incondizionato e obiettivo.</strong>
                                            </li>
                                            <li>
                                                Il regolamento potrà subire variazioni fino al momento del primo
                                                show che vale il punteggio.
                                            </li>
                                        </ul>
                                        <div className="alert mb-0 rules-alert-dark" style={{
                                            background: 'linear-gradient(135deg, rgba(194, 157, 84, 0.1), rgba(194, 157, 84, 0.05))',
                                            border: '2px solid var(--brand-secondary)',
                                            color: 'var(--brand-primary)'
                                        }}>
                                            <i className="bi bi-info-circle-fill me-2" style={{ color: 'var(--brand-secondary)' }}></i>
                                            Il regolamento ha scopo <strong>puramente ludico.</strong> Nessun
                                            bonus/malus deve incentivare comportamenti scorretti: giocate
                                            responsabilmente!
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <SectionAd placement="home" className="d-flex justify-content-center my-2" />
        </div>
    );
}

export default Rules;
